import React, { useState } from "react";
import { HorizontalScale } from "../../../../../components";

const HorizontalScaleList = () => {
  const [scaleValue, setScaleValue] = useState(null);
  const handleChange = (value) => {
    setScaleValue(value);
  };
  const handleUpdate = (value) => {
    setScaleValue(value);
  };
  return (
    <div className="flex flex-col gap-5">
      <HorizontalScale onChange={handleUpdate} />
      <HorizontalScale min={0} max={100} interval={5} onChange={handleChange} />
    </div>
  );
};

export default HorizontalScaleList;
